import {getSites, branchNames} from '../../api/builds'
import cloneNotEmpty from '../../utils/clone-object'
import lodash from 'lodash'

export const state = {
  currentSite: null,
  siteList: [],
  loggedIn: false,
  filter: {
    milestone: false,
    project_id: null,
    store_id: null,
    build_type_id: null,
    version: null,
    tc_build_id: null,
    artifact_type_id: null,
    branch_name: null,
    tags: [],
    exclude_tags: ['pr_auto'],
    conf: null
  },
  filterEmpty: {
    milestone: false,
    project_id: null,
    store_id: null,
    build_type_id: null,
    version: null,
    tc_build_id: null,
    artifact_type_id: null,
    branch_name: null,
    tags: [],
    exclude_tags: ['pr_auto'],
    conf: null
  },
  tagList: [],
  branchNameList: []
}

export const getters = {
  currentSite (state) {
    return state.currentSite
  },
  currentIdSite (state, getters) {
    if (getters.siteList && getters.siteList.length && getters.currentSite) {
      return getters.siteList.find((val) => val.name === getters.currentSite).id
    } else {
      return null
    }
  },
  getSiteName (state) {
    return (id) => {
      return state.siteList.find(val => val.id === id).name
    }
  },
  getSiteId (state) {
    return (name) => {
      return state.siteList.find(val => val.name === name).id
    }
  },
  siteList (state) {
    return state.siteList
  },
  loggedIn (state) {
    return state.loggedIn
  },
  filter (state) {
    return state.filter
  },
  filterEmpty (state) {
    return state.filterEmpty
  },
  tagList (state) {
    return state.tagList
  },
  branchNameList: (state) => state.branchNameList
}

export const mutations = {
  SET_CURRENT_SITE (state, site) {
    state.currentSite = site
  },
  SET_SITE_LIST (state, list) {
    state.siteList = list
  },
  SET_LOGGED_IN (state, value) {
    state.loggedIn = value
  },
  SET_TAG_LIST (state, list) {
    state.tagList = list
  },
  SET_TAGS (state, list) {
    state.filter.tags = list
  },
  SET_EXCLUDE_TAGS (state, list) {
    state.filter.exclude_tags = list
  },
  ADD_TAG (state, tag) {
    if (!state.filter.tags.includes(tag)) {
      state.filter.tags.push(tag)
    }
  },
  REMOVE_TAG (state, item) {
    state.filter.tags.splice(state.filter.tags.indexOf(item), 1)
    state.filter.tags = [...state.filter.tags]
  },
  SET_PROJECT (state, project) {
    state.filter.project_id = project
  },
  SET_STORE (state, store) {
    state.filter.store_id = store
  },
  SET_MILESTONE (state, value) {
    state.filter.milestone = value
  },
  SET_BUILD (state, value) {
    state.filter.build_type_id = value
  },
  SET_VERSION (state, value) {
    state.filter.version = value
  },
  SET_TC_BUILD (state, value) {
    state.filter.tc_build_id = value
  },
  SET_BRANCH_NAME (state, value) {
    state.filter.branch_name = value
  },
  SET_ARTIFACT (state, value) {
    state.filter.artifact_type_id = value
  },
  SET_FILTER (state, filter) {
    state.filter = filter
  },
  CLEAR_FILTER (state) {
    state.filter = lodash.cloneDeep(state.filterEmpty)
  },
  SET_BRANCH_NAME_LIST (state, value) {
    state.branchNameList = value
  }
}

export const actions = {
  getSiteList({commit, getters}) {
    if (getters.siteList.length > 0) {
      return Promise.resolve();
    }
    return getSites()
      .then((result) => {
        if (typeof result.data !== 'object') {
          throw Error('Bad sites data');
        }
        commit('SET_SITE_LIST', result.data)
        if (result.data.length > 0 && !getters.currentSite) {
          commit('SET_CURRENT_SITE', result.data[0].name)
        }
        commit('SET_LOGGED_IN', true)
        return Promise.resolve(result)
      })
      .catch((error) => {
        commit('SET_SITE_LIST', [])
        commit('SET_LOGGED_IN', false)
        return Promise.reject(error)
      })
  },

  getBranchNames ({commit, getters}, site) {
    let filter = cloneNotEmpty(getters.filter)
    if (filter) delete filter['branch_name']
    let data = {
      project: site,
      filter: filter
    }
    branchNames(data)
      .then(response => {
        commit('SET_BRANCH_NAME_LIST', response.data)
      })
      .catch(error => {
        console.log('getBranchNames err', error)
      })
  }
}
